document.addEventListener("DOMContentLoaded", function() {
    const seoTextContent = document.querySelector('.seo-text__content');
    const seoTextButtonWrap = document.querySelector('.seo-text__buttonWrap');

    if (window.matchMedia("(max-width: 559px)").matches) {
        if (seoTextContent) {
            const contentHeight = seoTextContent.offsetHeight;

            if (contentHeight <= 240) {
                seoTextButtonWrap.style.display = 'none';
                seoTextContent.classList.add('opened');
            } else {
                seoTextContent.style.height = '240px';
                seoTextContent.style.overflow = 'hidden';

                const seoTextButton = document.querySelector('.seo-text__button');
                if (seoTextButton) {
                    seoTextButton.addEventListener('click', function() {
                        seoTextContent.style.transition = "height 0.4s";
                        seoTextContent.style.height = contentHeight + 'px';
                        seoTextContent.style.overflow = 'visible';
                        seoTextContent.addEventListener('transitionend', function() {
                            seoTextContent.classList.add('opened');
                        }, { once: true });

                        seoTextButton.remove();
                    });
                }
            }
        }
    }
});
